"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureNames = exports.componentNames = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["WEB"] = "WEB";
    ComponentType["NATIVE"] = "NATIVE";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
exports.componentNames = {
    DATE_PICKER_VIEW: {
        WEB: 'DatePickerView.web',
        NATIVE: 'DatePickerView.native'
    },
    HOURLY_BREAKDOWN: {
        WEB: 'HourlyBreakdown.web',
        NATIVE: 'HourlyBreakdown.native'
    },
    ICON_BUTTON_WITH_MODAL: {
        WEB: 'IconButtonWithModal.web',
        NATIVE: 'IconButtonWithModal.native'
    },
    PAY_PERIOD_DAILY_BREAKDOWN_VIEW: {
        WEB: 'PayPeriodDailyBreakdownView.web',
        NATIVE: 'PayPeriodDailyBreakdownView.native'
    },
    PAY_PERIOD_HOURLY_BREAKDOWN_VIEW: {
        WEB: 'PayPeriodHourlyBreakdownView.web',
        NATIVE: 'PayPeriodHourlyBreakdownView.native'
    },
    PAY_PERIOD_PICKER_VIEW: {
        WEB: 'PayPeriodPickerView.web',
        NATIVE: 'PayPeriodPickerView.native'
    },
    PUNCH_CARD: { WEB: 'PunchCard.web', NATIVE: 'PunchCard.native' },
    PUNCH_CARD_LINK: { WEB: 'PunchCardLink.web', NATIVE: 'PunchCardLink.native' },
    PUNCH_CORRECTION_CARD: {
        WEB: 'PunchCorrectionCard.web',
        NATIVE: 'PunchCorrectionCard.native'
    },
    PUNCH_CORRECTION_CONFIRMATION_MODAL: {
        WEB: 'PunchCorrectionConfirmationModal.web',
        NATIVE: 'PunchCorrectionConfirmationModal.native'
    },
    PUNCH_CORRECTION_STATUS: {
        WEB: 'PunchCorrectionStatus.web',
        NATIVE: 'PunchCorrectionStatus.native'
    },
    PUNCH_DELETION_CONFIRMATION_MODAL: {
        WEB: 'PunchDeletionConfirmationModal.web',
        NATIVE: 'PunchDeletionConfirmationModal.native'
    },
    PUNCH_DETAILS_MODAL: {
        WEB: 'PunchDetailsModal.web',
        NATIVE: 'PunchDetailsModal.native'
    },
    PUNCH_ERROR_MODAL: {
        WEB: 'PunchErrorModal.web',
        NATIVE: 'PunchErrorModal.native'
    },
    PUNCH_MODAL: { WEB: 'PunchModal.web', NATIVE: 'PunchModal.native' },
    PUNCH_SECTION: { WEB: 'PunchSection.web', NATIVE: 'PunchSection.native' },
    PUNCH_SECTION_HEADER: {
        WEB: 'PunchSectionHeader.web',
        NATIVE: 'PunchSectionHeader.native'
    },
    PUNCH_SPINNER: { WEB: 'PunchSpinner.web', NATIVE: 'PunchSpinner.native' },
    PUNCH_TILE: { WEB: 'PunchTile.web', NATIVE: 'PunchTile.native' },
    PUNCH_TOAST_MODAL: {
        WEB: 'PunchToastModal.web',
        NATIVE: 'PunchToastModal.native'
    },
    SPINNER_OVERLAY: {
        WEB: 'SpinnerOverlay.web',
        NATIVE: 'SpinnerOverlay.native'
    },
    STOP_PROPAGATION_VIEW: {
        WEB: 'StopPropagationView.web',
        NATIVE: 'StopPropagationView.native'
    },
    TASK_ITEM: { WEB: 'TaskItem.web', NATIVE: 'TaskItem.native' },
    PUNCH_CORRECTION_BUTTON: {
        WEB: 'PunchCorrectionButton.web',
        NATIVE: 'PunchCorrectionButton.native'
    }
};
var featureNames;
(function (featureNames) {
    featureNames["DATE_PICKER_FEATURE"] = "DatePickerFeature";
    featureNames["HOURLY_BREAKDOWN_FEATURE"] = "HourlyBreakdownFeature";
    featureNames["PUNCH_FEATURE"] = "PunchFeature";
    featureNames["TIME_CARD_FEATURE"] = "TimecardFeature";
    featureNames["PUNCH_WORKFLOW_FEATURE"] = "PunchWorkflowFeature";
    featureNames["REPORT_TRAVEL_TIME_WORKFLOW_FEATURE"] = "ReportTravelTimeWorkflowFeature";
})(featureNames = exports.featureNames || (exports.featureNames = {}));
